<template>
  <div :class="['op--modal-container', {hide: !show}]">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="map-modal" @click.stop>
          <div class="close-button" @click="close">
              <i class="fa fa-times"></i>
          </div>
          <booking-map mapId="BookingMap" v-if="rerender" ref="bookingMap"></booking-map>
          <div class="action">
            <div class="location-input">
              <input type="text" autocomplete="disabled" placeholder="Drag the map to start" class="field-text set-location" v-model="keyInput">
              <button class="target-location" @click="getLocation"><i class="fa fa-crosshairs"></i></button>
            </div>
            <button class="op-btn btn-md btn-block btn-success search-submit" @click="saveLocation">Set <span class="target">{{target == 'extraStop' ? 'Extra Stop' : target}}</span> Location</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import request from 'browser-request'
import BookingMap from './BookingMap'
export default {
  components: { BookingMap },
  name: 'map-modal',
  data () {
    return {
      pinnedLocation: null,
      keyInput: '',
      rerender: false
    }
  },
  computed: {
    show () { return this.$store.state.searchMapModal.show },
    target () { return this.$store.state.searchMapModal.target },
    centeredLocation () { return this.$store.state.searchMapModal.location },
    extraStop () { return this.$store.state.reservation.extraStop },
    mapStore () { return this.$store.state.reservation.map }
  },
  methods: {
    close () {
      if (screen.width > 640) {
        document.body.classList.remove('widget-no-scroll')
      } else {
        window.fcWidget.show()
        document.body.classList.remove('widget-full')
      }
      this.$store.commit('setShowMapModal', {
        show: false,
        target: ''
      })
      this.$store.commit('reservation/setMapData', {init: false})
    },
    lookupCoordinates (coordinates) {
      let self = this

      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={LAT}%2C{LNG}&apiKey={API_KEY}'
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)
        .replace('{LAT}', coordinates.lat)
        .replace('{LNG}', coordinates.lng)
      request.get({
        url: url,
        json: true
      }, (err, res, body) => {
        if (err !== null) {
          self.pinnedLocation = null
          return
        }
        if (body.items.length > 0) {
          let item = body.items[0]
          self.pinnedLocation = {
            title: item.title,
            address1: item.address.street ? item.address.street : 'Unnamed Road',
            address2: item.address.houseNumber ? item.address.houseNumber : '',
            city: item.address.city,
            state: item.address.state,
            zip: item.address.postalCode,
            country: item.address.countryCode,
            lat: item.position.lat,
            lng: item.position.lng,
            geofenceId: -1
          }
          self.keyInput = item.title
          return
        }
        self.pinnedLocation = null
        return
      })
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      }
    },
    showPosition (position) {
      let center = {
        alt: 0,
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
      this.$store.commit('setMapLocation', center)
      this.$refs.bookingMap.centerMap(center)
    },
    saveLocation () {
      let self = this
      let finalResult = self.pinnedLocation
      let locationType = self.target.charAt(0).toUpperCase() + self.target.substr(1)
      if (self.target === 'charter') {
        self.$store.commit('reservation/setCharterData', {pickup: finalResult})
        self.$store.commit('reservation/setPickup', {
          leg: 'leg1',
          value: finalResult
        })
      } else if (self.target === 'extraStop') {
        self.$store.commit('reservation/setExtraStopLocationData', {
          leg: 'leg1',
          id: self.extraStop.leg1[0].id,
          value: finalResult
        })
      } else {
        self.$store.commit('reservation/set' + locationType, {
          leg: 'leg1',
          value: finalResult
        })
      }
      if (self.target === 'pickup') {
        self.$store.commit('airports/sortList', { lat: self.pinnedLocation.lat, lng: self.pinnedLocation.lng })
      }

      let trackData = {}
      trackData[`${this.target}Type`] = 'custom'
      this.$store.commit('tracking/setOpoliCnsData', trackData)

      // check leg and id
      self.$emit('change', {
        field: self.target,
        keyInput: self.keyInput,
        id: self.extraStop.leg1[0] ? self.extraStop.leg1[0].id : 0,
        leg: 'leg1',
        fromMap: true
      })

      self.close()
      // self.keyInput = ''
      self.pinnedLocation = null
      self.$store.commit('setMapLocation', null)
    }
  },
  watch: {
    centeredLocation (value) {
      if (value === null) {
        return
      }
      this.lookupCoordinates(value)
    },
    'mapStore.init': function (value) {
      let self = this
      if (value) {
        self.rerender = false
        setTimeout(() => {
          self.rerender = true
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
  
  .map-modal {
    position: relative;
    background-color: #fff;
    width: 550px;
    height: 480px;
    margin: auto;

    
    @media only screen and (max-width: 640px) {
      width: 100%;
      height: 100%;
    }
  }
}

.close-button{
  background-color: #fff;
  display: inline-block;
  position: absolute;
  padding: 8px 14px;
  border-radius: 5px;
  top: 15px;
  left: 15px;
  right: inherit;
  opacity: 1;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0,0,0,0.5);
  transition: all 350ms;
  cursor: pointer;

  i {
    font-size: 22px;
  }
}

.action {
	position: absolute;
	bottom: 0;
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	padding: 2rem 2.5rem;
  height: 150px;
  border-top: 1px solid #ddd;

  .location-input {
    position: relative;
    width: 100%;
    
    input {
      width: calc(100% - 38px);
    }
    .target-location {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      border: 1px solid #ccc;
      cursor: pointer;
      -webkit-box-shadow: -2px 0 3px rgba(0, 0, 0, 0.1);
      box-shadow: -2px 0 3px rgba(0, 0, 0, 0.1);
      width: 38px;

      i {
        font-size: 18px;
        padding: 10px;
        color: #2c3e50;
      }
    }
  }

	.target {
		text-transform: capitalize;
	}
}
</style>


// WEBPACK FOOTER //
// MapModal.vue?409557dc